module.exports = __webpack_public_path__ + "static/media/overview5_0.99de7c0e.png";